import { computed, Ref, ref } from 'vue'
import { DataTableFilter } from '@/types/DataTable'

interface PaymentStatusFilterPayload {
  label: string
  field: string
  multiple?: boolean
}

export function usePaymentStatusFilter({ label, field, multiple }: PaymentStatusFilterPayload): DataTableFilter<string> {
  const model: Ref<string | null> = ref('')

  const loading = ref(false)

  const ready = Promise.resolve(true)

  return {
    model,
    value: computed(() => model.value),
    items: computed(
      () => ([
        { title: 'Todos', value: '' },
        { title: 'Cancelado', value: 'Cancelado' },
        { title: 'Confirmado', value: 'Confirmado' },
        { title: 'Aguardando Pagamento', value: 'Aguardando Pagamento' },
        { title: 'Cortesia', value: 'Cortesia' },
        { title: 'Processando Pagamento', value: 'Processando Pagamento' },
        { title: 'Recusado', value: 'Recusado' },
      ]),
    ),
    label,
    field,
    type: 'select',
    loading,
    multiple,
    required: false,
    ready,
  }
}
